import { createWithEqualityFn } from "zustand/traditional";
import { shared } from "use-broadcast-ts";

const useSalesReceiptStore = createWithEqualityFn(
  shared((set) => ({
    categoryWiseSales: [],
    liabilities: [],
    discounts: [],
    tenderTypes: [],
    cashAccounts: [],
    expenses: [],
    creditCardFees: null,
    todaysCreditCardFees: null,
    askMyClient: null,
    cashOverUnderEditable: null,
    cashOverUnder: null,
    laborData: [],
    grandTotall: 0,
    reportStatus: null,
    clickBaconStatus: false,
    lastSyncedAt: null,
    syncLogs: [],
    hasGiftCardIssue: false,
    hasUncategorizedLabor: false,
    hasDiscountIssue: false,
    reportDate: "",
    extractedDiscount: null,
    serviceRevenue: [],
    paidIns: [],
    paidOuts: [],
    paidInOutId: null,
    isPaidInOutSynced: false,
    paidInOutSyncedAt: null,
    paidInOutSyncLogs: [],
    grandTotalNew: 0,
    setHasDiscountIssue: (hasDiscountIssue) => set({ hasDiscountIssue }),
    setHasUncategorizedLabor: (hasUncategorizedLabor) => set({ hasUncategorizedLabor }),
    setHasGiftCardIssue: (hasGiftCardIssue) => set({ hasGiftCardIssue }),
    setCategoryWiseSales: (categoryWiseSales) => set({ categoryWiseSales }),
    setLiabilities: (liabilities) => set({ liabilities }),
    setDiscounts: (discounts) => set({ discounts }),
    setTenderTypes: (tenderTypes) => set({ tenderTypes }),
    setCashAccounts: (cashAccounts) => set({ cashAccounts }),
    setExpenses: (expenses) => set({ expenses }),
    setCreditCardFees: (creditCardFees) => set({ creditCardFees }),
    setTodaysCreditCardFees: (todaysCreditCardFees) => set({ todaysCreditCardFees }),
    setLaborData: (laborData) => set({ laborData }),
    setAskMyClient: (askMyClient) => set({ askMyClient }),
    setCashOverUnderEditable: (cashOverUnderEditable) => set({ cashOverUnderEditable}),
    setCashOverUnder: (cashOverUnder) => set({ cashOverUnder }),
    setGrandTotall: (grandTotall) => set({ grandTotall }),
    setReportStatus: (reportStatus) => set({ reportStatus }),
    setClickBaconStatus: (clickBaconStatus) => set({ clickBaconStatus }),
    setLastSyncedAt: (lastSyncedAt) => set({ lastSyncedAt }),
    setSyncLogs: (syncLogs) => set({ syncLogs }),
    setReportDate: (reportDate) => set({ reportDate }),
    setExtractedDiscount: (extractedDiscount) => set({ extractedDiscount }),
    setServiceRevenue: (serviceRevenue) => set({ serviceRevenue }),
    setPaidIns: (paidIns) => set({ paidIns }),
    setPaidOuts: (paidOuts) => set({ paidOuts }),
    setPaidInOutId: (paidInOutId) => set({ paidInOutId }),
    setIsPaidInOutSynced: (isPaidInOutSynced) => set({ isPaidInOutSynced }),
    setPaidInOutSyncedAt: (paidInOutSyncedAt) => set({ paidInOutSyncedAt }),
    setPaidInOutSyncLogs: (paidInOutSyncLogs) => set({ paidInOutSyncLogs }),
    setGrandTotalNew: (grandTotalNew) => set({ grandTotalNew }),
  })),
  Object.is
);

export default useSalesReceiptStore;
